/* eslint-disable @typescript-eslint/no-unused-vars */
// ============================================================
// SIMADCA v3.0 – LoginPage.tsx FINAL
// Design: fotografie reală stânga + formular curat dreapta
// ============================================================

import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, Alert } from 'antd';
import {
  UserOutlined, LockOutlined,
  EyeInvisibleOutlined, EyeTwoTone,
  ArrowRightOutlined,
} from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import bgImage from '../assets/bg-simadca.png';

// ─── Conturi demo ─────────────────────────────────────────
const DEMO = [
  { label: 'Admin',    email: 'admin@simadca.ro',    pw: 'admin123',    color: '#6366f1' },
  { label: 'Operator', email: 'operator@simadca.ro', pw: 'operator123', color: '#10b981' },
  { label: 'Viewer',   email: 'viewer@simadca.ro',   pw: 'viewer123',   color: '#06b6d4' },
];

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const [form]    = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState<string | null>(null);

  const handleSubmit = async (vals: { email: string; password: string }) => {
    setLoading(true);
    setError(null);
    const res = await login(vals.email, vals.password);
    if (!res.success) setError(res.error ?? 'Autentificare eșuată.');
    setLoading(false);
  };

  const fillDemo = (email: string, pw: string) => {
    form.setFieldsValue({ email, password: pw });
    setError(null);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', fontFamily: "'Inter', sans-serif" }}>

      {/* ══ STÂNGA — Fotografie ══════════════════════════ */}
      <div
        className="lg-left-panel"
        style={{
          flex: '0 0 55%', position: 'relative',
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover', backgroundPosition: 'center',
          display: 'none',
        }}
      >
        {/* Overlay gradient */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(to top, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.15) 50%, rgba(0,0,0,0.05) 100%)',
        }} />

        {/* Text jos */}
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '36px', zIndex: 10 }}>
          {/* Badge LIVE */}
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 7,
            background: 'rgba(255,255,255,0.12)', backdropFilter: 'blur(8px)',
            borderRadius: 99, padding: '5px 14px', marginBottom: 18,
            border: '1px solid rgba(255,255,255,0.2)',
          }}>
            <span style={{
              width: 7, height: 7, borderRadius: '50%', background: '#10b981', display: 'inline-block',
              boxShadow: '0 0 0 3px rgba(16,185,129,0.35)',
              animation: 'ping-badge 1.5s ease infinite',
            }} />
            <span style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.85)', letterSpacing: '0.05em' }}>
              MONITORIZARE LIVE
            </span>
            <style>{`@keyframes ping-badge { 0%,100%{opacity:1}50%{opacity:0.6} }`}</style>
          </div>

          <h1 style={{
            fontSize: 30, fontWeight: 800, color: '#fff', lineHeight: 1.25,
            margin: '0 0 10px', letterSpacing: '-0.3px',
            textShadow: '0 2px 12px rgba(0,0,0,0.4)',
          }}>
            Monitorizare calitate apă<br />în zone agricole
          </h1>

          <p style={{
            color: 'rgba(255,255,255,0.72)', fontSize: 14, lineHeight: 1.65,
            margin: '0 0 20px', maxWidth: 420,
          }}>
            Detecție în timp real a antibioticelor, hormonilor și pesticidelor
            din apele de suprafață folosind senzori FO-SPR, SAW și SPE-MIP.
          </p>

          {/* Bullets tehnologii */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
            {[
              { icon: '🔬', text: 'Senzori FO-SPR, SAW, Electrochimici (SPE-MIP)' },
              { icon: '⚡', text: 'Alarmare automată la depășire LOD în timp real' },
              { icon: '🗺️', text: 'Acoperire națională — ferme, bazine, cursuri de apă' },
            ].map((b, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 16 }}>{b.icon}</span>
                <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', fontWeight: 500 }}>{b.text}</span>
              </div>
            ))}
          </div>

          <div style={{
            marginTop: 12, paddingTop: 16,
            borderTop: '1px solid rgba(255,255,255,0.15)',
            fontSize: 11, color: 'rgba(255,255,255,0.4)', lineHeight: 1.6,
          }}>
            INFOSEC CENTER SRL + INFLPR &nbsp;·&nbsp; Proiect PNTS SMIS 304244 &nbsp;·&nbsp; © 2026 SIMADCA
          </div>
        </div>
      </div>

      {/* Responsive */}
      <style>{`
        @media (min-width: 1024px) { .lg-left-panel { display: block !important; } }
      `}</style>

      {/* ══ DREAPTA — Formular ═══════════════════════════ */}
      <div style={{
        flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: '#f8fafc', padding: '32px 24px', overflowY: 'auto',
      }}>
        <div style={{ width: '100%', maxWidth: 400 }}>

          {/* Logo + titlu */}
          <div style={{ marginBottom: 28, textAlign: 'center' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 10,
              marginBottom: 22,
            }}>
              <div style={{
                width: 44, height: 44, borderRadius: 12,
                background: 'linear-gradient(135deg, #6366f1, #4f46e5)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 900, fontSize: 22, color: '#fff',
                boxShadow: '0 4px 14px rgba(99,102,241,0.35)',
                userSelect: 'none',
              }}>
                S
              </div>
              <span style={{ fontWeight: 800, fontSize: 26, color: '#0f172a', letterSpacing: '-0.5px' }}>
                SIMADCA
              </span>
            </div>
            <h2 style={{ fontSize: 24, fontWeight: 800, color: '#0f172a', margin: '0 0 6px', letterSpacing: '-0.4px' }}>
              Bun venit înapoi
            </h2>
            <p style={{ color: '#64748b', fontSize: 14, margin: 0 }}>
              Autentificați-vă pentru a accesa platforma SIMADCA
            </p>
          </div>

          {/* Eroare autentificare */}
          {error && (
            <Alert
              message={error} type="error" showIcon closable
              onClose={() => setError(null)}
              style={{ marginBottom: 18, borderRadius: 10 }}
            />
          )}

          {/* Card formular */}
          <div style={{
            background: '#fff', borderRadius: 16,
            border: '1px solid #e2e8f0',
            boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
            padding: '28px 28px 24px',
          }}>
            <Form
              form={form} layout="vertical"
              onFinish={handleSubmit}
              requiredMark={false} size="large"
            >
              <Form.Item
                label={<span style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>Email</span>}
                name="email"
                rules={[
                  { required: true, message: 'Introduceți adresa de email.' },
                  { type: 'email',  message: 'Adresă invalidă.' },
                ]}
                style={{ marginBottom: 14 }}
              >
                <Input
                  prefix={<UserOutlined style={{ color: '#94a3b8' }} />}
                  placeholder="email@simadca.ro"
                  autoComplete="email"
                  style={{ height: 44, borderRadius: 10 }}
                />
              </Form.Item>

              <Form.Item
                label={<span style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>Parolă</span>}
                name="password"
                rules={[{ required: true, message: 'Introduceți parola.' }]}
                style={{ marginBottom: 10 }}
              >
                <Input.Password
                  prefix={<LockOutlined style={{ color: '#94a3b8' }} />}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  iconRender={v => v ? <EyeTwoTone twoToneColor="#6366f1" /> : <EyeInvisibleOutlined />}
                  style={{ height: 44, borderRadius: 10 }}
                />
              </Form.Item>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <Checkbox style={{ fontSize: 13, color: '#64748b' }}>Ține-mă minte</Checkbox>
                <button
                  type="button"
                  onClick={() => alert('Contactați: admin@simadca.ro')}
                  style={{ background: 'none', border: 'none', color: '#6366f1', fontSize: 13, fontWeight: 500, cursor: 'pointer', padding: 0, fontFamily: 'inherit' }}
                >
                  Parolă uitată?
                </button>
              </div>

              <Button
                type="primary" htmlType="submit"
                loading={loading} block
                icon={!loading ? <ArrowRightOutlined /> : undefined}
                style={{
                  height: 46, fontSize: 14, fontWeight: 700, borderRadius: 10,
                  background: loading ? undefined : '#6366f1', border: 'none',
                  boxShadow: '0 2px 10px rgba(99,102,241,0.3)',
                }}
              >
                {loading ? 'Se verifică...' : 'Autentificare'}
              </Button>
            </Form>
          </div>

          {/* Demo accounts */}
          <div style={{ marginTop: 22 }}>
            <div style={{ position: 'relative', textAlign: 'center', marginBottom: 14 }}>
              <div style={{ position: 'absolute', top: '50%', left: 0, right: 0, height: 1, background: '#e2e8f0' }} />
              <span style={{ position: 'relative', background: '#f8fafc', padding: '0 12px', fontSize: 11, color: '#94a3b8', fontWeight: 500, letterSpacing: '0.05em' }}>
                CONTURI DEMO
              </span>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 8 }}>
              {DEMO.map(d => (
                <button
                  key={d.label} onClick={() => fillDemo(d.email, d.pw)}
                  style={{ padding: '9px 6px', borderRadius: 10, cursor: 'pointer', border: `1.5px solid ${d.color}25`, background: `${d.color}07`, fontFamily: 'inherit', transition: 'all 0.15s', textAlign: 'center' }}
                  onMouseEnter={e => {
                    const el = e.currentTarget as HTMLButtonElement;
                    el.style.background = `${d.color}14`; el.style.borderColor = `${d.color}55`; el.style.transform = 'translateY(-1px)';
                  }}
                  onMouseLeave={e => {
                    const el = e.currentTarget as HTMLButtonElement;
                    el.style.background = `${d.color}07`; el.style.borderColor = `${d.color}25`; el.style.transform = 'translateY(0)';
                  }}
                >
                  <div style={{ fontWeight: 700, fontSize: 13, color: d.color }}>{d.label}</div>
                </button>
              ))}
            </div>
            <p style={{ textAlign: 'center', fontSize: 11, color: '#94a3b8', marginTop: 8 }}>
              Click pentru completare automată
            </p>
          </div>

          <p style={{ textAlign: 'center', fontSize: 11, color: '#cbd5e1', marginTop: 20 }}>
            SIMADCA v3.0 · SMIS 304244
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;